module.exports = __webpack_public_path__ + "img/Weapon_85.1187ea62.png";